import api from "api/api";

export const createBackupManagerQuery = async (data) =>
  await api.post("settings/manager_backup", data);

export const deleteBackupManagerQuery = async (id) =>
  await api.delete(`settings/manager_backup/${id}`);

export const getBackupManagerByIdQuery = async (id) =>
  await api.get(`settings/manager_backup/${id}`);

export const getBackupManagerListQuery = async () =>
  await api.get("settings/manager_backup");

export const updateBackupManagerQuery = async (id, data) =>
  await api.put(`settings/manager_backup/${id}`, data);
